'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM896 896h-768v-768h768v768zM320 768h384c35.2 0 64-28.8 64-64v-384c0-35.2-28.8-64-64-64h-384c-35.2 0-64 28.8-64 64v384c0 35.2 28.8 64 64 64zM320 696h384v7.884c-0.034 0.040-0.076 0.082-0.116 0.116h-383.77c-0.040-0.034-0.082-0.076-0.114-0.116v-7.884zM320.114 320h383.77c0.040 0.034 0.082 0.076 0.116 0.116v7.884h-384v-7.886c0.034-0.038 0.076-0.080 0.114-0.114zM704 344v16h-384v-16h384zM704 376v16h-384v-16h384zM704 408v16h-384v-16h384zM704 440v16h-384v-16h384zM704 472v16h-384v-16h384zM704 504v16h-384v-16h384zM704 536v16h-384v-16h384zM704 568v16h-384v-16h384zM704 600v16h-384v-16h384zM704 632v16h-384v-16h384zM704 664v16h-384v-16h384z' })
    ));
};